import * as yup from 'yup';
import { ISuggestion, SuggestionSchema } from '../../common';

export const BaseDataSuggestionSchema = yup.object({
  caregiverDescription: SuggestionSchema.nullable(),
  powerOfAttorneyDescription: SuggestionSchema.nullable(),
  doctorGeneralSubjectArea: SuggestionSchema.nullable(),
});

export type IBaseDataSuggestion = {
  caregiverDescription: ISuggestion;
  powerOfAttorneyDescription: ISuggestion;
  doctorGeneralSubjectArea: ISuggestion;
};
